@if (!loaded) {
  <app-visionnaire-loader class="ipe:w-full" />
}

@if (loaded) {
  <app-modal-container
    title="{{ 'CRM.saleTasks.ownership' | translate }}: {{ task.seller }}"
    (closeButton)="closeDialog()"
  >
    <div class="task-detail-modal">
      <div class="task-detail-modal__topbar">
        <div class="task-detail-modal__topbar-copy">
          <span class="task-detail-modal__eyebrow font-walter">
            {{ 'crm.pages.task.detail.task.detail.task' | translate }}
          </span>
          <h3 class="task-detail-modal__title">
            {{ task.summary }}
          </h3>
        </div>

        <div class="task-detail-modal__topbar-actions">
          @if (task.state !== 'completed' && canAssignTo()) {
            <button
              type="button"
              class="task-detail-modal__btn task-detail-modal__btn--secondary"
              (click)="openAssignToModal()"
            >
              <i class="icon-ipe-sales-tasks" aria-hidden="true"></i>
              <span>{{ 'CRM.LEAD.ASSIGN_TO' | translate }}</span>
            </button>
          }
        </div>
      </div>

      <div class="task-detail-modal__content">
        <section class="task-detail-section">
          <div class="task-detail-section__header">
            <span class="task-detail-section__eyebrow font-walter">
              {{ 'crm.pages.task.detail.task.detail.dettagli' | translate }}
            </span>
            <h4 class="task-detail-section__title">
              {{ 'CRM.saleTasks.ownership' | translate }}
            </h4>
          </div>

          <div class="task-detail-section__grid">
            @if (task.customerId && !customerClickable) {
              <div class="task-detail-section__card task-detail-section__card--customer">
                <div class="task-detail-section__label">
                  {{ 'CLIENTE' | translate }}
                </div>

                <button
                  type="button"
                  class="task-detail-section__customer-btn"
                  (click)="openCustomerWithId(task?.customerId)"
                >
                  <span class="task-detail-section__customer-name">
                    {{ task?.customer | titlecase }}
                  </span>

                  <span class="task-detail-section__customer-icon" aria-hidden="true">
                    <svg width="18" height="18" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2 2.5C2 2.22386 2.22386 2 2.5 2H5.5C5.77614 2 6 2.22386 6 2.5C6 2.77614 5.77614 3 5.5 3H3V5.5C3 5.77614 2.77614 6 2.5 6C2.22386 6 2 5.77614 2 5.5V2.5ZM9 2.5C9 2.22386 9.22386 2 9.5 2H12.5C12.7761 2 13 2.22386 13 2.5V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3H9.5C9.22386 3 9 2.77614 9 2.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H2.5C2.22386 13 2 12.7761 2 12.5V9.5C2 9.22386 2.22386 9 2.5 9ZM12.5 9C12.7761 9 13 9.22386 13 9.5V12.5C13 12.7761 12.7761 13 12.5 13H9.5C9.22386 13 9 12.7761 9 12.5C9 12.2239 9.22386 12 9.5 12H12V9.5C12 9.22386 12.2239 9 12.5 9Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </span>
                </button>
              </div>
            }

            <div class="task-detail-section__card">
              <div class="task-detail-section__label">
                {{ 'generics.cols.summary' | translate }}
              </div>
              <div class="task-detail-section__value">
                {{ task.summary }}
              </div>
            </div>

            <div class="task-detail-section__card">
              <div class="task-detail-section__label">
                {{ 'generics.cols.expirationDate' | translate }}
              </div>
              <div class="task-detail-section__value">
                {{ !!task.expirationDate && (task.expirationDate * 1000 | date: 'dd/MM/yyyy') || '' }}
              </div>
            </div>

            @if (task.completionDate) {
              <div class="task-detail-section__card">
                <div class="task-detail-section__label">
                  {{ 'generics.cols.completionDate' | translate }}
                </div>
                <div class="task-detail-section__value">
                  {{ (task.completionDate * 1000 | date: 'dd/MM/yyyy') || '' }}
                </div>
              </div>
            }
          </div>
        </section>

        <section class="task-detail-section">
          <div class="task-detail-section__header">
            <span class="task-detail-section__eyebrow font-walter">
              {{ 'crm.pages.task.detail.task.detail.nota' | translate }}
            </span>
            <h4 class="task-detail-section__title">
              {{ 'generics.cols.note' | translate }}
            </h4>
          </div>

          <form [formGroup]="noteForm" class="task-detail-section__form">
            <app-input
              class="task-detail-section__textarea"
              formControlName="note"
              [textAreaOption]="null"
              [withBorder]="true"
              [label]="'generics.cols.note' | translate"
              type="textarea"
            ></app-input>
          </form>
        </section>
      </div>

      @if (task.editable && task.state !== 'completed') {
        <div class="task-detail-modal__footer">
          <button
            type="button"
            class="task-detail-modal__btn task-detail-modal__btn--secondary"
            [disabled]="noteForm.invalid"
            (click)="saveTask()"
          >
            <i class="icon-ipe-save" aria-hidden="true"></i>
            <span>{{ 'SAVE' | translate }}</span>
          </button>

          <button
            type="button"
            class="task-detail-modal__btn task-detail-modal__btn--primary force-text-white"
            [disabled]="noteForm.invalid"
            (click)="completeTask()"
          >
            <i class="icon-ipe-verified-done" aria-hidden="true"></i>
            <span>{{ 'CRM.saleTasks.setTaskAsCompleted' | translate }}</span>
          </button>
        </div>
      }
    </div>
  </app-modal-container>
}
